<template>
    <div class="navigation vertical-container vertical-container--in-secondary-side">
        <div class="vertical-container__header">
            <div class="navigation-title test__header">Přizpůsobení</div>
        </div>

        <div class="vertical-container__content">
            <ul class="navigation-list test__content">
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-option'}" class="navigation-list__link">
                        Projekt
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-option-building'}" class="navigation-list__link">
                        Budovy
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-option-accessory'}" class="navigation-list__link">
                        Příslušenství
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-option-phase'}" class="navigation-list__link">
                        Etapy
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-option-floor-plan'}" class="navigation-list__link">
                        Půdorysy
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-option-file'}" class="navigation-list__link">
                        Soubory
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-option-image'}" class="navigation-list__link">
                        Obrázky
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-option-status'}" class="navigation-list__link">
                        Statusy
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-option-type'}" class="navigation-list__link">
                        Typy
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-option-disposition'}" class="navigation-list__link">
                        Dispozice
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProjectOptionNav',
}
</script>
